import { HttpClient, httpResource } from '@angular/common/http';
import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';

import type {
  StormDrainageAssetResponse,
  UpdateStormDrainageAssetRequest,
} from '../../domain/assets/storm-drainage-asset.model';
import { assertIsDefined } from '../../domain/types';
import { TenantContext } from '../tenant.context';

@Injectable({
  providedIn: 'root',
})
export class StormDrainageAssetService {
  readonly #httpClient = inject(HttpClient);
  readonly #tenantContext = inject(TenantContext);

  stormDrainageAssetResource(stormDrainageAssetId: Signal<string>) {
    return httpResource<StormDrainageAssetResponse>(() => {
      const tenantId = this.#tenantContext.currentTenantId();
      const stormDrainageAssetIdValue = stormDrainageAssetId();
      return tenantId && stormDrainageAssetIdValue
        ? `api/tenants/${tenantId}/assets/storm-drainage/${stormDrainageAssetIdValue}`
        : undefined;
    });
  }

  updateStormDrainageAsset(
    assetId: string,
    request: UpdateStormDrainageAssetRequest,
  ) {
    const tenantId = this.#tenantContext.currentTenantId();
    assertIsDefined(tenantId);
    return this.#httpClient.put<StormDrainageAssetResponse>(
      `api/tenants/${tenantId}/assets/storm-drainage/${assetId}`,
      request,
    );
  }
}
